<template>
  <div>
    <el-card shadow="never">
      <template #header>
        <div class="header">
          <el-breadcrumb class="breadcrumb" separator="/">
            <el-breadcrumb-item>工作台</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
      <div style="width:80%">
        <el-form :model="searchForm" inline label-width="140px">
          <el-form-item label="时间范围">
            <el-date-picker
              v-model="searchForm.TimeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="YYYY-MM-DD hh:mm:ss"
              value-format="YYYY-MM-DD hh:mm:ss"
            />
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="getInfo">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never" style="margin-top: 20px;">
      <template #header>
        <div class="header">
          数据统计
        </div>
      </template>
      <div>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="b1">
              <p>公司数量</p>
              <p>{{baseData.company_count}}</p>
              <div class="b2">正常数量：<em>{{baseData.company_normal_count}}</em></div>
              <div class="b2">待审核数量：<em>{{baseData.company_audit_count}}</em></div>
              <div class="b2">冻结数量：<em>{{baseData.company_freeze_count}}</em></div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="b1">
              <p>用户数</p>
              <p>{{baseData.member_count}}</p>
              <div class="b2">正常数量：<em>{{baseData.member_normal_count}}</em></div>
              <div class="b2">冻结数量：<em>{{baseData.member_freeze_count}}</em></div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="b1">
              <p>订单数</p>
              <p>{{baseData.order_count}}</p>
              <div class="b2">待支付：<em>{{baseData.order_nopay_count}}</em></div>
              <div class="b2">已支付：<em>{{baseData.order_pay_count}}</em></div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <el-card shadow="never" style="margin-top: 20px;">
      <div>
        <div ref="memberChart" style="width:100%;height: 400px;"></div>
      </div>
    </el-card>
  </div>
</template>
<script lang="ts" setup>
import { reactive, onMounted, provide, ref } from 'vue'
import api from '@/api/index'
import { ElMessage, ElLoading } from 'element-plus'
import * as echarts from "echarts"
provide("echarts", echarts)
const baseData:any = reactive({
  company_freeze_count:0,
  company_audit_count:0,
  company_count:0,
  company_normal_count:0,
  member_count:0,
  member_freeze_count:0,
  member_normal_count:0,
  order_count:0,
  order_nopay_count:0,
  order_pay_count:0,
  companyList:[],
  order_data:{
    date:[],
    count:[],
  }
});
const searchForm:any = reactive({
  companyid:"",
  status:"",
  TimeRange:[],
});
const getInfo = () => {
  const loading = ElLoading.service({lock: true})
  let data = {
    companyid:searchForm.companyid,
    status:searchForm.status,
    start_time:searchForm.TimeRange[0],
    end_time:searchForm.TimeRange[1],
  }
  api.accessoryApi.getInfo(data).then((res:any)=>{
    if(res.code==200){
      baseData.company_freeze_count = res.data.company_freeze_count
      baseData.company_audit_count = res.data.company_audit_count
      baseData.company_count = res.data.company_count
      baseData.company_normal_count = res.data.company_normal_count
      baseData.member_count = res.data.member_count
      baseData.member_freeze_count = res.data.member_freeze_count
      baseData.member_normal_count = res.data.member_normal_count
      baseData.order_count = res.data.order_count
      baseData.order_pay_count = res.data.order_pay_count
      baseData.order_nopay_count = res.data.order_nopay_count
      baseData.order_data = res.data.order_data
      createMemberEchart()
    }else{
      ElMessage.error(res.message)
    }
    loading.close()
  })
  loading.close()
}

const memberChart = ref()
const memberOption = {
  title: {
    text: '订单数'
  },
  xAxis: {
    type: 'category',
    data: baseData.order_data.date
  },
  yAxis: {
    type: 'value'
  },
  tooltip: {
    trigger: 'item'
  },
  series: [
    {
      data: baseData.order_data.count,
      type: 'line'
    }
  ]
};
const createMemberEchart = () => {
  let memberChartEl = memberChart.value
  let userEc = echarts.init(memberChartEl, "light")
  console.log(baseData.order_data)
  memberOption.series[0].data = baseData.order_data.count
  memberOption.xAxis.data = baseData.order_data.date
  userEc.setOption(memberOption)
}
const getCompanyList = () => {
  api.companyApi.alllist({}).then((res:any)=>{
    if(res.code==200){
      baseData.companyList = res.data.list
    }else{
      ElMessage.error(res.message)
    }
  })
}
onMounted(() => {
  let start_time = new Date().getTime()-86400000*7
  let end_time = new Date().getTime()
  let start_time_morth = new Date(start_time).getMonth() + 1 > 9 ? new Date(start_time).getMonth() + 1 : '0'+ (new Date(start_time).getMonth()+1)
  let end_time_morth = new Date(end_time).getMonth() + 1 > 9 ? new Date(end_time).getMonth() + 1 : '0'+ (new Date(end_time).getMonth()+1)
  let start_date = new Date(start_time).getFullYear() + "-"+ start_time_morth + "-"+ (new Date(start_time).getDate() > 9 ? new Date(start_time).getDate() : "0" + new Date(start_time).getDate()) + " 12:00:00"
  let end_date = new Date(end_time).getFullYear() + "-"+ end_time_morth + "-"+ (new Date(end_time).getDate() > 9 ? new Date(end_time).getDate() : "0" + new Date(end_time).getDate()) + " 12:00:00"
  searchForm.TimeRange = [ start_date, end_date ]
  getCompanyList()
  getInfo()
})
</script>
<style scoped>
.b1{
  text-align: center;
  background-color: #fdf6ec;
  border: 1px solid #ebebeb;
}
.b1 p:first-child{
  font-size: 16px;
}
.b1 p:nth-child(2){
  font-size: 24px;
  font-weight: bold;
}
.b2{
  display: inline-block;
  font-size: 14px;
  margin:0 10px 10px;
  font-weight: bold;
}
.b2 em{
  font-style: normal;
  color: red;
}
</style>